export default {
  kind: {
    ewallet: '数字钱包',
    crypto: '加密货币',
    bank: '银行卡',
    alipay: '支付宝',
  },
  loading: '加载中…',
  feeFree: '免手续费 · 到账更快',
  feePct: '手续费 {n}%',
  defaultTag: '默认',
  setDefault: '设为默认',
  edit: '编辑账户',
  delete: '删除',
  add: '＋ 添加{name}',
  pickTitle: '选择提现账户',
  formAdd: '添加{name}',
  formEdit: '编辑{name}',
  currency: '币种',
  currencyType: '货币类型',
  network: '主网 / 链',
  channel: '钱包渠道',
  holderName: '姓名',
  cardHolder: '持卡人姓名',
  realName: '真实姓名',
  bankName: '开户银行',
  region: '开户地区',
  branch: '开户网点',
  pickRegion: '选择开户地区',
  pickCurrency: '币种',
  phCurrencySearch: '请输入搜索关键字',
  address: '钱包地址',
  cardNo: '银行卡号',
  bankAccount: '银行账号',
  account: '账号',
  phHolder: '请输入姓名(与账号实名一致)',
  phCardHolder: '请输入持卡人姓名',
  phRealName: '请输入真实姓名',
  phBankAccount: '请输入收款账号',
  phBranch: '请输入开户网点',
  phRegionSelect: '请选择开户地区',
  regionCn: '中国',
  regionJp: '日本',
  regionTw: '台湾',
  regionHk: '香港',
  regionMo: '澳门',
  regionSg: '新加坡',
  phBankSelect: '请选择开户银行',
  phBankSearch: '搜索银行名称',
  bankEmpty: '没有匹配的银行',
  countryEmpty: '没有匹配的国家/地区',
  phAlipay: '支付宝账号(手机号 / 邮箱)',
  phCardNo: '银行卡号',
  phAddress: 'USDT({ch})钱包地址',
  phEwallet: '{ch} 钱包账号',
  hintEdit: '· 姓名与开户信息不可修改,如需变更请删除后重新添加',
  hintCrypto: '· 请仔细核对地址与主网,转错链将无法找回',
  hintIdentity: '· 账户需与本人实名一致,以确保到账',
  saveEdit: '保存修改',
  saveUse: '保存并使用',
  toastDefault: '已设为默认提现账户',
  toastDeleted: '已删除该提现账户',
  toastSaved: '已保存修改',
  toastSavedUse: '已保存并使用该账户',
  errAlipay: '支付宝账号应为手机号(可带国际区号)或邮箱,请检查后重填',
  errBank: '银行卡号应为 16–19 位数字,请检查卡号',
  errEwallet: '{ch} 账号应为 6 位以上字母或数字',
  errCrypto: 'USDT({ch})地址格式不正确,请核对后重填',
  errNameMatch: '提现账户姓名需与已有账户保持一致({name})',

  fundTitle: '输入资金密码',
  fundDesc: {
    generic: '为保障资金安全,请输入 6 位资金密码以继续操作。',
    add: '请输入资金密码以添加收款账户。',
    deposit: '请输入资金密码以确认本次充值。',
    setDefault: '请输入资金密码以设置默认提现账户。',
    edit: '请输入资金密码以编辑收款账户。',
    delete: '请输入资金密码以删除该提现账户。',
    withdraw: '请输入资金密码以确认本次提现。',
    cancelWithdraw: '请输入资金密码以撤销该提现申请。',
    changeLoginPwd: '请输入资金密码以修改登录密码。',
    changePhone: '请输入资金密码以更换绑定手机。',
    changeEmail: '请输入资金密码以更换绑定邮箱。',
  },
  fundPh: '6 位资金密码',
  fundConfirm: '确认',
  fundHint: '连续输错 5 次将锁定 2 小时。',
  errFundFormat: '请输入 6 位资金密码',
  errFundFail: '资金密码错误',
  /** 1030 锁定：按服务端剩余时间（retry_after_seconds / Retry-After / locked_until） */
  errFundLocked: '资金密码连续输错 5 次，已锁定，请 {wait}后再试',
  errFundLockedSoon: '资金密码连续输错 5 次，已锁定，请稍后再试',
}
